import type { IBaseComponentProps } from 'components/base/types'
import Icon from 'components/icon'
import type { IconFactor } from '@/types/elements/icon'
import { defineComponent, type FunctionalComponent } from 'vue'
import { tv } from "tailwind-variants";

type TStyleVariant = 'primary' | 'blue' | 'gray'

type InfoCardProps = IBaseComponentProps & {
  title: string
  subtitle: string
  icon?: IconFactor
  titleClass?: string
  subtitleClass?: string
  heightClass?: string
  bodyRight?: FunctionalComponent<any>
  variant?: TStyleVariant
}

const InfoCardClass = tv({
  base: 'px-5 py-3 border border-gray-300 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-6',
  variants: {
    color: {
      primary: 'bg-primary-100 border-primary-500 text-primary-500 rounded-sm border',
      blue: 'bg-primary-100 border-primary-500 text-primary-500 rounded-sm border',
      gray: 'bg-gray-100 border-gray-300 text-gray-500 rounded-sm border'
    },
  }
})

const InfoCard = defineComponent<InfoCardProps>({
  setup(props) {
    return () => (
      <div
        class={
          InfoCardClass({ color: props.variant }) + ' ' + (props.heightClass ?? 'h-[66px]')
        }
      >
        <div class="flex-1 flex flex-col justify-start">
          <div class="flex items-center gap-1">
            {props.icon && (
              <Icon src={props.icon} class="shrink-0" />
            )}
            <div
              class={
                props.titleClass ??
                'text-gray-500 text-sm font-bold leading-[21px]'
              }
            >
              {props.title}
            </div>
          </div>
          <div
            class={
              'mt-1 ' +
              (props.subtitleClass ??
                'self-stretch text-gray-900 text-xs font-normal')
            }
          >
            {props.subtitle}
          </div>
        </div>
        {props.bodyRight && (
          <div class="w-full md:w-auto">
            <props.bodyRight />
          </div>
        )}
      </div>
    )
  },
})

InfoCard.props = ['title', 'subtitle', 'icon', 'titleClass', 'heightClass', 'subtitleClass', 'variant', 'bodyRight']

export default InfoCard
